if (!customElements.get('localization-form')) {
  customElements.define('localization-form', class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.input = this.querySelector('input[name="country_code"]');
      this.links = this.querySelectorAll(".js-country-localisation-link");

      this.addListeners();
    }

    addListeners() {
      this.links.forEach(link => link.addEventListener('click', event => this.countrySelected(event)));
    }

    countrySelected(event) {
      event.preventDefault();

      this.input.value = event.currentTarget.dataset.value;

      if (this.form) this.form.submit();
    }
  });
}